// @ts-nocheck
import { combineReducers } from 'redux';
import { kanbanReducer } from './kanbanReducer';
import { projectReducer } from './projectReducer';
import { commentsReducer } from './commentsReducer';
import { modalReducer } from './modalReducer';
import { mediaProbeApi } from '../../../../media/api/mediaProbeApi';

export const rootReducer = combineReducers({
  project: projectReducer,
  kanban: kanbanReducer,
  comments: commentsReducer,
  modal: modalReducer,
  [mediaProbeApi.reducerPath]: mediaProbeApi.reducer,
});
